module.exports = __webpack_public_path__ + "img/t3-18.91d4d96b.svg";